import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "bv-dialog__head" };
const _hoisted_2 = { class: "bv-dialog__title" };
const _hoisted_3 = { class: "bv-dialog__foot" };
import { reactive, ref, watch } from "vue";
import { benefitsVerificationService, } from "@/services/benefitsVerificationService";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BenefitsVerificationDialog',
    props: {
        modelValue: { type: Boolean },
        anchor: {},
        record: { default: null },
        prefill: { default: null }
    },
    emits: ["update:modelValue", "saved"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const yesNo = [
            { title: "Unknown", value: null },
            { title: "Yes", value: true },
            { title: "No", value: false },
        ];
        const blank = () => ({
            coverageActive: null,
            inNetwork: null,
            priorAuthRequired: null,
            payerName: "",
            memberId: "",
            planName: "",
            priorAuthEntity: "",
            deductibleIndividual: "",
            deductibleFamily: "",
            outOfPocketIndividual: "",
            outOfPocketFamily: "",
            copay: "",
            coinsurance: "",
            services: "",
            repName: "",
            callReferenceNumber: "",
            eligibilityStatus: "",
            notes: "",
        });
        const form = reactive(blank());
        const saving = ref(false);
        const error = ref("");
        function load() {
            Object.assign(form, blank());
            const record = props.record;
            if (record) {
                const d = record.details || {};
                Object.assign(form, {
                    coverageActive: record.coverageActive,
                    inNetwork: record.inNetwork,
                    priorAuthRequired: record.priorAuthRequired,
                    payerName: record.payerName,
                    memberId: record.memberId,
                    planName: record.planName,
                    priorAuthEntity: d.priorAuthEntity || "",
                    deductibleIndividual: d.deductibleIndividual || "",
                    deductibleFamily: d.deductibleFamily || "",
                    outOfPocketIndividual: d.outOfPocketIndividual || "",
                    outOfPocketFamily: d.outOfPocketFamily || "",
                    copay: d.copay || "",
                    coinsurance: d.coinsurance || "",
                    services: (Array.isArray(d.services) ? d.services : []).map((s) => s.name).join(", "),
                    repName: d.repName || "",
                    callReferenceNumber: d.callReferenceNumber || "",
                    eligibilityStatus: d.eligibilityStatus || "",
                    notes: d.notes || "",
                });
            }
            else if (props.prefill) {
                form.payerName = props.prefill.payerName || "";
                form.memberId = props.prefill.memberId || "";
            }
        }
        watch(() => props.modelValue, (open) => {
            if (open) {
                error.value = "";
                load();
            }
        });
        function toInput() {
            const existing = props.record?.details || {};
            return {
                payerName: form.payerName.trim(),
                memberId: form.memberId.trim(),
                planName: form.planName.trim(),
                coverageActive: form.coverageActive,
                inNetwork: form.inNetwork,
                priorAuthRequired: form.priorAuthRequired,
                details: {
                    ...existing,
                    priorAuthEntity: form.priorAuthEntity.trim(),
                    deductibleIndividual: form.deductibleIndividual.trim(),
                    deductibleFamily: form.deductibleFamily.trim(),
                    outOfPocketIndividual: form.outOfPocketIndividual.trim(),
                    outOfPocketFamily: form.outOfPocketFamily.trim(),
                    copay: form.copay.trim(),
                    coinsurance: form.coinsurance.trim(),
                    services: form.services
                        .split(",")
                        .map((s) => s.trim())
                        .filter(Boolean)
                        .map((name) => {
                        const previous = (existing.services || []).find((s) => s.name === name);
                        return previous || { name, covered: null, priorAuthRequired: null, notes: "" };
                    }),
                    repName: form.repName.trim(),
                    callReferenceNumber: form.callReferenceNumber.trim(),
                    eligibilityStatus: form.eligibilityStatus.trim(),
                    notes: form.notes.trim(),
                },
            };
        }
        async function save() {
            saving.value = true;
            error.value = "";
            try {
                const input = toInput();
                const saved = props.record
                    ? await benefitsVerificationService.update(props.record.id, input)
                    : await benefitsVerificationService.create(props.anchor, { ...input, status: "VERIFIED" });
                emit("saved", saved);
                emit("update:modelValue", false);
            }
            catch (err) {
                error.value = err?.message || "Failed to save benefits";
            }
            finally {
                saving.value = false;
            }
        }
        return (_ctx, _cache) => {
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                "model-value": __props.modelValue,
                "max-width": "680",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => (emit('update:modelValue', $event)))
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                        class: "bv-dialog",
                        rounded: "sm"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "bv-dialog__eyebrow" }, "Benefit verification", -1)),
                                _createElementVNode("span", _hoisted_2, _toDisplayString(__props.record ? "Edit benefits" : "Record benefits"), 1),
                                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "bv-dialog__hint" }, "What the payer said. Leave a field blank when it was not covered on the call.", -1))
                            ]),
                            _createVNode(_component_v_card_text, { class: "bv-dialog__body" }, {
                                default: _withCtx(() => [
                                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "bv-dialog__section" }, "Eligibility", -1)),
                                    _createVNode(_component_v_row, { dense: "" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "4"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_select, {
                                                        modelValue: form.coverageActive,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.coverageActive) = $event)),
                                                        items: yesNo,
                                                        label: "Coverage active",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "4"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_select, {
                                                        modelValue: form.inNetwork,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.inNetwork) = $event)),
                                                        items: yesNo,
                                                        label: "In network",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "4"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_select, {
                                                        modelValue: form.priorAuthRequired,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.priorAuthRequired) = $event)),
                                                        items: yesNo,
                                                        label: "Prior auth required",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "bv-dialog__section" }, "Plan", -1)),
                                    _createVNode(_component_v_row, { dense: "" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "6"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.payerName,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.payerName) = $event)),
                                                        label: "Payer",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "6"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.memberId,
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.memberId) = $event)),
                                                        label: "Member ID",
                                                        class: "bv-dialog__mono",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "6"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.planName,
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.planName) = $event)),
                                                        label: "Plan name",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "6"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.priorAuthEntity,
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((form.priorAuthEntity) = $event)),
                                                        label: "Prior auth handled by",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "bv-dialog__section" }, "Cost sharing", -1)),
                                    _createVNode(_component_v_row, { dense: "" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                                cols: "6",
                                                sm: "3"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.deductibleIndividual,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.deductibleIndividual) = $event)),
                                                        label: "Deductible, individual",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "6",
                                                sm: "3"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.deductibleFamily,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((form.deductibleFamily) = $event)),
                                                        label: "Deductible, family",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "6",
                                                sm: "3"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.outOfPocketIndividual,
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((form.outOfPocketIndividual) = $event)),
                                                        label: "OOP max, individual",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "6",
                                                sm: "3"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.outOfPocketFamily,
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((form.outOfPocketFamily) = $event)),
                                                        label: "OOP max, family",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "6",
                                                sm: "3"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.copay,
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((form.copay) = $event)),
                                                        label: "Copay",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "6",
                                                sm: "3"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.coinsurance,
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((form.coinsurance) = $event)),
                                                        label: "Coinsurance",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "6"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.services,
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((form.services) = $event)),
                                                        label: "Services verified, comma separated",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "bv-dialog__section" }, "Call", -1)),
                                    _createVNode(_component_v_row, { dense: "" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "4"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.repName,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((form.repName) = $event)),
                                                        label: "Rep name",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "4"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.callReferenceNumber,
                                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((form.callReferenceNumber) = $event)),
                                                        label: "Call reference #",
                                                        class: "bv-dialog__mono",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "4"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: form.eligibilityStatus,
                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((form.eligibilityStatus) = $event)),
                                                        label: "Eligibility note",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_textarea, {
                                                        modelValue: form.notes,
                                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((form.notes) = $event)),
                                                        label: "Notes",
                                                        rows: "2",
                                                        "auto-grow": "",
                                                        density: "compact",
                                                        "hide-details": "auto"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            (error.value)
                                ? (_openBlock(), _createBlock(_component_v_alert, {
                                    key: 0,
                                    type: "error",
                                    variant: "tonal",
                                    density: "compact",
                                    class: "mx-4 mb-2"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(error.value), 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_v_btn, {
                                    variant: "text",
                                    size: "small",
                                    rounded: "sm",
                                    onClick: _cache[18] || (_cache[18] = ($event) => (emit('update:modelValue', false)))
                                }, {
                                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                            _createTextVNode("Cancel", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createVNode(_component_v_btn, {
                                    color: "primary",
                                    variant: "flat",
                                    size: "small",
                                    rounded: "sm",
                                    loading: saving.value,
                                    onClick: save
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(__props.record ? "Save changes" : "Save as verified"), 1)
                                    ]),
                                    _: 1
                                }, 8, ["loading"])
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    }
});
